import React, { useState } from "react";
import styles from "./Checklist.module.scss";
import { useChecklist } from "./hooks";
import useAuthState from "../../hooks/useAuthState";

import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { EcommerceChecklist } from "./ChecklistDetails/EcommerceChecklist";
import { PoliticalChecklist } from "./ChecklistDetails/PoliticalChecklist";
import { NonProfitChecklist } from "./ChecklistDetails/NonProfitChecklist";

function Checklist({ accountType, isNmiAccount }) {
  const checklistProps = useChecklist(accountType, isNmiAccount);
  const { percentageProgress } = checklistProps;

  const { isLoggedIn } = useAuthState();

  if (!isLoggedIn) {
    return null;
  }

  return (
    <div className={styles.walkthroughChecklist}>
      <div>
        <h2 className={styles.heading}>Next Steps</h2>
        {accountType === "NonProfit" ? (
          <NonProfitChecklist {...checklistProps} />
        ) : accountType === "Political" ? (
          <PoliticalChecklist {...checklistProps} />
        ) : (
          <EcommerceChecklist {...checklistProps} />
        )}
      </div>

      <div className={styles.progressCircleGraph}>
        <CircularProgressbar
          value={percentageProgress}
          text={`${percentageProgress}%`}
          strokeWidth={5}
          styles={{
            path: {
              stroke: `#ff7373`,
              strokeLinecap: "butt",
              transition: "stroke-dashoffset 0.5s ease 0s",
              transformOrigin: "center center"
            },
            text: {
              fill: "#2C2C2C",
              fontSize: "24px"
            }
          }}
        />
        <div className={styles.progressCircleGraphDesc}>
          Complete your profile its {percentageProgress}% complete
        </div>
      </div>
    </div>
  );
}

export default Checklist;
